import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import { getAppEnabled } from '../../../../Resources/Organization/Apps/AppsData.js'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch'
import { toggleEnabledWithEntity } from '../Redux/Actions.js'
import { GUSTO } from '../AppsData.js'
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel'

const GustoButton = () => {
  const appEnabled = useSelector(getAppEnabled(GUSTO))
  const dispatch = useDispatch()

  const onSwitchChange = (event, checked) => {
    if (checked) {
      window.location = '/app/gusto/authorize'
    } else {
      dispatch(toggleEnabledWithEntity(GUSTO))
    }
  }
  
  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Switch checked={appEnabled} onChange={onSwitchChange} />}
          label={appEnabled ? 'Active' : 'Disabled'}
        />
      </Grid>
      {appEnabled && (
        <Grid item xs={12}>
          <Button variant='outlined' color='primary' onClick={() => (window.location = '/app/gusto/employee_match')}>
            Edit Employee Matching
          </Button>
        </Grid>
      )}
    </Grid>
    )
  
}

export default GustoButton
